import type { APIError, TFunction } from "core/entities";

export function formatApiErrorMessage(
  apiError: APIError | undefined,
  t: TFunction
) {
  if (!apiError) {
    return t("Next:Core:Error");
  }
  const { status, info, message: genericErrorMessage } = apiError;
  const statusText = status ? `${status}: ` : "";
  const errorCode = info?.error?.code;
  const errorText =
    apiError.info?.error?.message ||
    (errorCode && t(errorCode)) ||
    genericErrorMessage ||
    "";
  return `${statusText}${errorText}`;
}
